<template>
    <div style="display: flex; flex-direction: column;">
        <div v-if="isSellingLead" style="width: 100%;" v-for="(item, i) in lead.vehicles_of_interest" @click="navigateToDetail(item)">
            <div style="margin-bottom: 5px;">
                <vehicle-chip :stock-listing="item"></vehicle-chip>
            </div>
        </div>
        <div v-if="!isSellingLead" style="width: 100%;" v-for="(item, i) in lead.appraisals">
            <div style="margin-bottom: 5px;">
<!--                <vehicle-chip :stock-listing="item.vehicle"></vehicle-chip>-->
                <appraisal-chip :appraisal="item"></appraisal-chip>
            </div>
        </div>
    </div>
</template>

<script>
import {floor, round} from "lodash";
import VehicleChip from "../VehicleChip.vue";
import {LeadTypes} from "../../classes/Api/Lead";
import AppraisalChip from "./AppraisalChip.vue";

export default {
    components: {AppraisalChip, VehicleChip},
    props: {
        lead: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            containerWidth: 0
        }
    },
    computed: {
        isSellingLead() {
            return this.lead.type === LeadTypes.SALES
        },
        items() {
            return this.lead.detail.length
        }
    },
    methods: {
        thumbnailUrl(url) {
            return url.replace('_dimensions_', 'h50')
        },
        navigateToDetail(item) {
            this.$root.navigateTo('vehicles/' + item.id + '/overview')
        }
    }
}
</script>

<style lang="scss" scoped>
    .detail-item-container {
        display: flex;

        .detail-item {
            padding: .5rem 1rem;
            background: #ededed;
            border-radius: 20px;
            display: flex;
            margin-right: 1rem;
            min-width: 180px;

            &.missing-item-count {
                min-width: auto;
                white-space: nowrap;
            }

            &:hover {
                background: #ddd;
            }

            img {
                max-height: 25px;
                border-radius: 3px;
            }

            span {
                vertical-align: middle;
                margin-left: .5rem;
                margin-right: .5rem;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                flex-grow:1;
                font-size: 14px;
                line-height: 25px;
            }
        }
    }
</style>